import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

html {
  font-size: 100%;
  scroll-behavior: smooth;
}

body {
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 170%;
  font-weight: 300;
  color: ${(props) => props.theme.colors.body};
  background-color: #fff;
}
`;

export default GlobalStyles;
